var _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_5_1",
    "data-name": "Component 5 \u2013 1",
    viewBox: "0 0 375.132 94"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_4_1",
    "data-name": "Component 4 \u2013 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_3_1",
    "data-name": "Component 3 \u2013 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 94,
    height: 94,
    fill: "#2a2a2a"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x2: 43,
    transform: "translate(25.5 47)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    y1: 43,
    transform: "translate(47 25.5)",
    fill: "none",
    stroke: "#f6f6f6",
    strokeMiterlimit: 10,
    strokeWidth: 15
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Add_a_category",
    "data-name": "Add a category",
    transform: "translate(135.132 58.737)",
    fontSize: 36,
    fontFamily: "Karrik-Regular, Karrik"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add a user"))));
};
export default __webpack_public_path__ + "static/media/add_user.3594ff12.svg";
export { SvgComponent as ReactComponent };